import React from 'react'
import { Modal } from 'antd'
import { AiFillExclamationCircle } from 'react-icons/ai'

const Confirm = ({ title = "Perform this action?", message = "", okText ="Proceed", onOk = () => null, cancelText = "Cancel", onCancel = () => null }) => {
    Modal.confirm({
        title,
        icon: <AiFillExclamationCircle />,
        content: message,
        okText,
        cancelText,
        onOk,
        onCancel
    })
}

export default Confirm